import builder from '../builder';
import HelpWheel from '../../streamline-icons/bold/help-wheel.svg';

export default builder('IconHelpWheelBold', HelpWheel);
